import React, { useEffect, useState, useCallback, useRef } from 'react'
import { Form, Input, Button, Card, message, Spin } from 'antd'
import { useConfig } from '../../contexts/ConfigContext'
import { useCompany } from '../../contexts/CompanyContext'
import { useSecureRequest } from '../../hooks/useSecureRequest'
import { useRefetchOnFocus } from '../../hooks/useRefetchOnFocus'
function SettingsView() {
  const { config } = useConfig()
  const { securePost } = useSecureRequest()
  const { companies } = useCompany()
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()
  const lastFetchedCompanyUid = useRef<string | null>(null)

  const fetchConfig = useCallback(async (isBackground = false) => {
    if (!config.key || !companies.current?.uid) return
    if (!isBackground) setLoading(true)
    try {
      const res = await securePost('/module/config/get', {
        session: config.session,
        company: companies.current.uid
      })
      if (res && Array.isArray(res)) {
        // Encontrar o mapear configs
        const emailConf = res.find((c: any) => c.key === 'admin_contact_email')?.string_value || ''
        const titleConf = res.find((c: any) => c.key === 'admin_dashboard_title')?.string_value || ''
        form.setFieldsValue({
          contact_email: emailConf,
          dashboard_title: titleConf
        })
      }
    } catch (err) {
      console.error(err)
      message.error('Error al cargar configuraciones')
    } finally {
      if (!isBackground) setLoading(false)
    }
  }, [config.key, config.session, companies.current?.uid, form])

  useEffect(() => {
    if (config.key && companies.current?.uid && lastFetchedCompanyUid.current !== companies.current.uid) {
      lastFetchedCompanyUid.current = companies.current.uid
      fetchConfig()
    }
  }, [config.key, companies.current?.uid, fetchConfig])

  useRefetchOnFocus(fetchConfig)

  const handleSave = async (values: any) => {
    try {
      await securePost('/config/save', {
        session: config.session,
        company: companies.current.uid,
        configs: [
          { key: 'admin_contact_email', type: 'string', string_value: values.contact_email },
          { key: 'admin_dashboard_title', type: 'string', string_value: values.dashboard_title }
        ]
      })
      message.success('Configuraciones guardadas exitosamente')
      fetchConfig()
    } catch (err) {
      console.error(err)
      message.error('Error al guardar configuraciones')
    }
  }

  return (
    <div>
      <h3>Configuraciones Administrativas</h3>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', margin: '40px 0' }}>
          <Spin />
        </div>
      ) : (
        <Card title="Opciones Generales del Módulo" style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.05)', borderRadius: 8 }}>
          <Form form={form} layout="vertical" onFinish={handleSave}>
            <Form.Item name="contact_email" label="Email de Contacto Administrativo" rules={[{ type: 'email', message: 'Ingrese un email válido' }]}>
              <Input placeholder="admin@ryo-erp.com" />
            </Form.Item>
            <Form.Item name="dashboard_title" label="Título Personalizado de Bienvenida">
              <Input placeholder="Panel Administrativo" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Guardar Configuración
              </Button>
            </Form.Item>
          </Form>
        </Card>
      )}
    </div>
  )
}

export default SettingsView
